import React, { useCallback, useMemo } from 'react'
import { DropDownList } from '@/components/dropDownList'
import context from '@/context'

export const IndividualSelector = React.memo(function IndividualSelector (props) {
  const { onChange, value, dataSource, onlyActive = false } = props
  const details = useMemo(() => {
    return {
      icon: 'show',
      link: context.isInternalApp() ? '/individuals/' : '/demographics/individuals/',
      field: 'id',
      text: '​' // Zero width space to have a truthy empty string
    }
  }, [])

  const getDataSource = useCallback((request, options) => {
    return dataSource(onlyActive, request, options)
  }, [dataSource, onlyActive])

  return (<DropDownList
    dataSource={getDataSource}
    onChange={onChange}
    value={value}
    itemsDetail={details} />)
})



// WEBPACK FOOTER //
// ./src/components/individualSelector.js